import { sortObject } from '../utils/sort-by-field';

interface NotificationType {
  type: 'boolean';
}

type NotificationObject = {
  device: NotificationType;
  discharge: NotificationType;
  item: NotificationType;
  material: NotificationType;
  mix: NotificationType;
  mixCharge: NotificationType;
  order: NotificationType;
  project: NotificationType;
  truck: NotificationType;
  truckCharge: NotificationType;
};

const Notification: NotificationObject = {
  device: { type: 'boolean' },
  discharge: { type: 'boolean' },
  item: { type: 'boolean' },
  material: { type: 'boolean' },
  mix: { type: 'boolean' },
  mixCharge: { type: 'boolean' },
  order: { type: 'boolean' },
  project: { type: 'boolean' },
  truck: { type: 'boolean' },
  truckCharge: { type: 'boolean' },
};

function isNotificationSettingKey(key: string): key is keyof NotificationObject {
  return key in Notification;
}

export const checkNotificationModel = (data: { [key: string]: any }): Partial<Record<keyof NotificationObject, boolean>> => {
  const result: Partial<Record<keyof NotificationObject, boolean>> = {};

  if (data) {
    Object.keys(data).forEach((key) => {
      if (isNotificationSettingKey(key) && typeof data[key] === Notification[key].type) {
        result[key as keyof NotificationObject] = data[key];
      }
    });
  }

  return sortObject(result);
};
